import renderComponent from 'recompose/renderComponent';
import branch from 'recompose/branch';

import Periods from './Periods';
import PeriodsPaid from './PeriodsPaid';
import createSelectPeriods from './selectPeriods';


export default branch(
  ({ paid, subId }) => (paid && subId),
  renderComponent(PeriodsPaid)
)(Periods);

export { createSelectPeriods };
